// extracted by mini-css-extract-plugin
export default {"primaryButton":"CustomButton_primaryButton__x+wct","secondaryButton":"CustomButton_secondaryButton__lrc15"};